import React from 'react';
import { Link } from 'react-router-dom';
import { FaShoppingCart } from 'react-icons/fa';
import { useCart } from '../context/CartContext';
import { useState, useEffect, useRef } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navRef = useRef(null);
  const buttonRef = useRef(null);


  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };


  const closeMenu = () => {
    setIsMenuOpen(false);
  };


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        navRef.current &&
        buttonRef.current &&
        !navRef.current.contains(event.target) &&
        !buttonRef.current.contains(event.target)
      ) {
        closeMenu();
      }
    };


    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        closeMenu();
      }
    };


    if (isMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }


    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  const { getCartCount } = useCart();
  const cartCount = getCartCount();

  return (
    <header>
      <div className="header-container">
        <Link to="/" className="logo-section">
          <img src="/images/logo.jpg" alt="Sororin Logo" className="logo-image" />
          <span className="logo-text">Sororin</span>
        </Link>
        
                <button 
          ref={buttonRef}
          className="hamburger-menu" 
          onClick={toggleMenu}
          aria-label="Toggle menu">
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </button>

<nav ref={navRef} className={isMenuOpen ? 'active' : ''}>
          <ul>
            <li><Link to="/" onClick={closeMenu}>Αρχική</Link></li>
            <li><Link to="/about" onClick={closeMenu}>Σχετικά</Link></li>
            <li><Link to="/contact" onClick={closeMenu}>Επικοινωνία</Link></li>
            <li>
              <Link to="/cart" className="cart-icon-wrapper" onClick={closeMenu}>
                <FaShoppingCart className="cart-icon" />
                {cartCount > 0 && <span className="cart-count">{cartCount}</span>}
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header;